export class Base64 {
    static utf8ToBase64(str: string) {
        return window.btoa(encodeURIComponent(escape(str)));
    }

    static base64ToUtf8(str: string) {
        return unescape(decodeURIComponent(window.atob(str)));
    }
}
